import { useState } from 'react'

import { Button } from '../../components/ui/button'
import { ConfirmDialog } from '../ConfigurePage/components/DeleteConfirmDialog'

export interface RunCancelButtonProps {
  /** Human-readable label, e.g. "RCA" or "PM". Used in the dialog copy. */
  agentLabel: string
  /** Current run state — button hides unless this is pending_dispatch or running. */
  state: string
  /** Async cancel handler. Errors are surfaced through the caller. */
  onCancel: () => Promise<void>
  busy?: boolean
}

const CANCELLABLE = new Set(['pending_dispatch', 'running'])

/**
 * Per-run "Cancel run" affordance shown in the run-detail header.
 * Gated to pending_dispatch / running states so the button disappears on
 * terminal rows. Confirmation dialog prevents misclicks.
 */
export function RunCancelButton({
  agentLabel,
  state,
  onCancel,
  busy = false
}: RunCancelButtonProps) {
  const [confirmOpen, setConfirmOpen] = useState(false)
  if (!CANCELLABLE.has(state)) return null
  return (
    <>
      <Button
        variant="outline"
        size="sm"
        className="border-destructive/40 bg-destructive/10 text-destructive hover:bg-destructive/20 hover:text-destructive"
        onClick={() => setConfirmOpen(true)}
        disabled={busy}
      >
        Cancel run
      </Button>
      <ConfirmDialog
        open={confirmOpen}
        onOpenChange={setConfirmOpen}
        title={`Cancel this ${agentLabel} run?`}
        description="The agent will stop on its next checkpoint and the run will be marked cancelled."
        confirmLabel="Cancel run"
        destructive
        busy={busy}
        onConfirm={() => {
          setConfirmOpen(false)
          void onCancel()
        }}
      />
    </>
  )
}
